import React from "react";

export const IconPremiumSmall = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.1367" cy="10" r="9.5" fill="url(#paint0_linear_4779_103103)" stroke="white" />
      <path
        d="M12.4883 13.4897H7.78828C7.57828 13.4897 7.34328 13.3247 7.27328 13.1247L5.20328 7.33469C4.90828 6.50469 5.25328 6.24969 5.96328 6.75969L7.91328 8.15469C8.23828 8.37969 8.60828 8.26469 8.74828 7.89969L9.62828 5.55469C9.90828 4.80469 10.3733 4.80469 10.6533 5.55469L11.5333 7.89969C11.6733 8.26469 12.0433 8.37969 12.3633 8.15469L14.1933 6.84969C14.9733 6.28969 15.3483 6.57469 15.0283 7.47969L13.0083 13.1347C12.9333 13.3247 12.6983 13.4897 12.4883 13.4897Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.38672 15H12.8867" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.88672 11H11.3867" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient
          id="paint0_linear_4779_103103"
          x1="10.1367"
          y1="0"
          x2="10.1367"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEDF3F" />
          <stop offset="1" stopColor="#F7871D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IconPremium24 = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11.5" fill="url(#paint0_linear_8050_134459)" stroke="white" />
      <path
        d="M14.8141 16.1853H9.17406C8.92206 16.1853 8.64006 15.9873 8.55606 15.7473L6.07206 8.79928C5.71806 7.80328 6.13206 7.49728 6.98406 8.10928L9.32406 9.78328C9.71406 10.0533 10.1581 9.91528 10.3261 9.47728L11.3821 6.66328C11.7181 5.76328 12.2761 5.76328 12.6121 6.66328L13.6681 9.47728C13.8361 9.91528 14.2801 10.0533 14.6641 9.78328L16.8601 8.21728C17.7961 7.54528 18.2461 7.88728 17.8621 8.97328L15.4381 15.7593C15.3481 15.9873 15.0661 16.1853 14.8141 16.1853Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.69531 17.9961H15.2953" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5 13.1953H13.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_8050_134459" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FEDF3F" />
          <stop offset="1" stopColor="#F7871D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const IconPremium = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="15.5" fill="url(#paint0_linear_4409_76912)" stroke="white" />
      <path
        d="M19.7547 21.5804H12.2347C11.8987 21.5804 11.5227 21.3164 11.4107 20.9964L8.09869 11.7324C7.62669 10.4044 8.17869 9.99638 9.31469 10.8124L12.4347 13.0444C12.9547 13.4044 13.5467 13.2204 13.7707 12.6364L15.1787 8.88438C15.6267 7.68437 16.3707 7.68437 16.8187 8.88438L18.2267 12.6364C18.4507 13.2204 19.0427 13.4044 19.5547 13.0444L22.4827 10.9564C23.7307 10.0604 24.3307 10.5164 23.8187 11.9644L20.5867 21.0124C20.4667 21.3164 20.0907 21.5804 19.7547 21.5804Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.6016 24H20.4016" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 17.6016H18" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <linearGradient id="paint0_linear_4409_76912" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FEDF3F" />
          <stop offset="1" stopColor="#F7871D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconPremium;
